module.exports = __webpack_public_path__ + "static/img/bg_jz@2x.818e90bf.png";